import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.primaryColor};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    height: 100vh;
  }

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    display: inline-flex;
  }

  .slide {
    overflow: hidden;
    transform: scale(1);
    transform-origin: center center;
    transition: transform 0.8s ease-in-out, opacity 0.8s ease-in-out;
    opacity: 0;
  }
  .slide.active {
    width: 100%;
    height: 100%;
    transition: transform 0.8s ease-in-out, opacity 0.8s ease-in-out;
    transform: scale(1);
    opacity: 1;
  }
`;

export const RightArrow = styled.img`
  width: ${({ width }) => (width ? width : '24px')};
  position: absolute;
  cursor: pointer;
  right: 16px;
  filter: drop-shadow(0 0 4px #333);
  z-index: 10;
`;
export const LeftArrow = styled(RightArrow)`
  left: 16px;
  transform: rotate(180deg);
`;

export const Dot = styled.div`
  position: absolute;
  bottom: 20px;
  display: flex;
  gap: 0 24px;
`;

export const DotItem = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  cursor: pointer;
  transform: scale(1);
  transition: transform 0.4s ease-in-out;

  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 18px;
    height: 18px;
    border: 2px solid #fff;
    border-radius: 50%;
  }

  &.active {
    background-color: #fff;
    transform: scale(1.4);
    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
    &::before {
    }
  }
`;
